// src/roles.ts
var RoleOptions = [
  "superadmin",
  "admin",
  "student",
  "researcher",
  "community-curator",
  "funder"
];
var AssignableRoleOptions = [
  "admin",
  "student",
  "researcher",
  "community-curator",
  "funder"
];
var PermissionOptions = [
  "publish",
  "manage-group-universities",
  "list-affiliations",
  "read-all-users",
  "read-affiliations",
  "read-users",
  "review",
  "create-invitations",
  "access-manage-affiliations-page",
  "access-manage-departments-page",
  "access-manage-branding-page",
  "create-university",
  "delete-university",
  "update-university",
  "update-branding",
  "create-affiliation",
  "update-affiliation",
  "list-all-manuscripts",
  "read-university-statistics",
  "update-manuscript-doi",
  "manage-announcements"
];

// src/affiliations.ts
var AffiliationStatuses = ["approved", "rejected", "pending"];

// src/manuscripts.ts
var ManuscriptStatuses = [
  "composing",
  "under-review",
  "changes-requested",
  "proofing",
  "preparing-final-version",
  "published",
  "cancelled",
  "ready-for-publication"
];
var PositionsInPdf = [
  "top-left",
  "top-center",
  "top-right",
  "bottom-left",
  "bottom-center",
  "bottom-right"
];

// src/notifications.ts
var ApiNotificationFilters = ["read", "unread", "all"];

// src/reviews.ts
var ReviewStatuses = [
  "pending",
  "approved",
  "changes-requested",
  "declined",
  "expired"
];
var SubmittedReviewStatuses = [
  "approved",
  "changes-requested",
  "declined"
];
var AuthorResponseReviewStatuses = [
  "changes-requested"
];
var AUTHOR_RESPONSE_MIN_LENGTH = 50;
function authorResponseLength(text) {
  return text.trim().replace(/\s+/g, " ").length;
}

// src/branding.ts
var LogoPositions = ["left", "center", "right"];
var QuestionTypes = ["text", "options"];
function isContentTypeAllowed(branding, contentType) {
  return !branding?.allowedContentTypes || branding.allowedContentTypes.includes(contentType);
}

// src/statistics.ts
var TimeSeriesGranularities = ["monthly", "yearly"];
var PublicationTimeSeriesTypes = [
  "views",
  "downloads",
  "impressions",
  "authors",
  "reviewers",
  "funders",
  "publications",
  "composing"
];

// src/templates.ts
var TemplateFormats = ["docx", "odt"];

// src/announcements.ts
var AnnouncementStatuses = ["draft", "published", "retired"];

// src/doi.ts
var DOI_PREFIX = /^(?:(?:https?:\/\/)?(?:www\.|dx\.)?doi\.org\/|doi:?\s*)/i;
var DOI_PATTERN = /^10\.\d+(?:\.\d+)*\/\S+$/;
function normalizeDoi(doi) {
  let bare = doi.trim();
  while (DOI_PREFIX.test(bare)) {
    bare = bare.replace(DOI_PREFIX, "").trim();
  }
  return bare;
}
function isValidDoi(doi) {
  return DOI_PATTERN.test(doi);
}
function doiUrl(doi) {
  const path = encodeURI(normalizeDoi(doi)).replace(/#/g, "%23").replace(/\?/g, "%3F");
  return `https://doi.org/${path}`;
}
function doiDisplayUrl(doi) {
  return `https://doi.org/${normalizeDoi(doi)}`;
}
export {
  AUTHOR_RESPONSE_MIN_LENGTH,
  AffiliationStatuses,
  AnnouncementStatuses,
  ApiNotificationFilters,
  AssignableRoleOptions,
  AuthorResponseReviewStatuses,
  LogoPositions,
  ManuscriptStatuses,
  PermissionOptions,
  PositionsInPdf,
  PublicationTimeSeriesTypes,
  QuestionTypes,
  ReviewStatuses,
  RoleOptions,
  SubmittedReviewStatuses,
  TemplateFormats,
  TimeSeriesGranularities,
  authorResponseLength,
  doiDisplayUrl,
  doiUrl,
  isContentTypeAllowed,
  isValidDoi,
  normalizeDoi
};
//# sourceMappingURL=index.mjs.map